<div class="custom-navbar">
  <div class="container px-5">
    <div class="row">
      <div class="col-12">
        <mat-toolbar>
          <div class="menu-button">
            <button mat-icon-button (click)="onToggleSidenav()">
              <mat-icon>menu</mat-icon>
            </button>
          </div>
          <div>
            <a routerLink="/appuntamenti">
              <img
                class="logo-navbar"
                src="./assets/images/logo-colori.png"
                alt="logo"
              />
            </a>
          </div>
          <div class="justify-content-end w-100 navbar-menu">
            <ul *ngIf="!auth" class="navigation-items">
              <li>
                <a href="https://drfeel.com/" target="_blank">Home</a>
              </li>

              <li>
                <a routerLink="/login" routerLinkActive="activeLink">Accedi </a>
              </li>
            </ul>
            <ul *ngIf="auth" class="navigation-items">
              <li>
                <a routerLink="/appuntamenti" routerLinkActive="activeLink"
                  >Appuntamenti</a
                >
              </li>
              <li>
                <a routerLink="/storico" routerLinkActive="activeLink"
                  >Storico</a
                >
              </li>
              <li *ngIf="isHm">
                <a routerLink="/patients" routerLinkActive="activeLink"
                  >Lista pazienti</a
                >
              </li>
              <li *ngIf="!env.production">
                <a routerLink="/chat" routerLinkActive="activeLink">Chat</a>
              </li>
              <li>
                <a routerLink="/assistenza" routerLinkActive="activeLink"
                  >Centro Assistenza</a
                >
              </li>
            </ul>
          </div>
        </mat-toolbar>
      </div>
    </div>
  </div>
</div>
